(() => {
  if (window.kachingPackPreviewLoaded) return;
  window.kachingPackPreviewLoaded = true;

  const barSelector = '.kaching-bundles__bar';
  const previewSelector = '[data-kaching-pack-preview]';
  const chooserSelector = '.kaching-bundles__collection-product__choose-product-button';

  function openPicker(bar, slotIndex, event) {
    event.preventDefault();
    event.stopPropagation();
    const preview = bar.querySelector(previewSelector);
    const button = event.currentTarget;
    button.disabled = true;

    // Wait for Kaching to mount its own picker before forwarding the click.
    const observer = new MutationObserver(forwardClick);
    const timeout = setTimeout(cleanup, 3000);
    function cleanup() {
      observer.disconnect();
      clearTimeout(timeout);
      button.disabled = false;
    }
    function forwardClick() {
      const chooser = Array.from(bar.querySelectorAll(chooserSelector))
        .filter((element) => !preview.contains(element))[slotIndex];
      if (!chooser || !bar.classList.contains('kaching-bundles__bar--selected')) return;
      cleanup();
      chooser.click();
    }
    observer.observe(bar, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    bar.querySelector('.kaching-bundles__bar-main')?.click();
    forwardClick();
  }

  function updateBlock(block) {
    let deal;
    try {
      deal = JSON.parse(block.getAttribute('deal-block') || '{}');
    } catch {
      return;
    }
    if (!deal.collectionBreaksEnabled) return;
    const packs = deal.dealBars?.filter((offer) =>
      offer.dealBarType === 'quantity-break' && offer.quantity === 2
    ) || [];
    packs.forEach((pack) => addPackPreview(block, deal, pack));
  }

  function addPackPreview(block, deal, pack) {
    const bar = Array.from(block.querySelectorAll(barSelector))
      .find((element) => element.dataset.dealBarId === pack.id);
    if (!bar || bar.querySelector(previewSelector)) return;

    // Read display content only; never clone Kaching's inputs or selection state.
    const product = Array.from(block.querySelectorAll('.kaching-bundles__collection-product'))
      .find((element) => !element.closest(previewSelector) && element.querySelector('.kaching-bundles__collection-product__title'));
    const image = product?.querySelector('img');
    const title = product?.querySelector('.kaching-bundles__collection-product__title');
    const wrapper = bar.querySelector('.kaching-bundles__bar-wrapper');
    if (!image || !title || !wrapper) return;

    const preview = document.createElement('div');
    preview.dataset.kachingPackPreview = '';
    preview.className = 'kaching-bundles__bar-collection-products';
    const row = document.createElement('div');
    row.className = 'kaching-pack-preview__product';
    const photo = document.createElement('img');
    photo.src = image.src;
    photo.alt = '';
    const name = document.createElement('span');
    name.textContent = title.textContent;
    row.append(photo, name);

    preview.append(row);
    for (let slotIndex = 0; slotIndex < pack.quantity - 1; slotIndex += 1) {
      const choice = document.createElement('div');
      choice.className = 'kaching-pack-preview__choice';
      const plus = document.createElement('span');
      plus.className = 'kaching-pack-preview__plus';
      plus.textContent = '+';
      plus.setAttribute('aria-hidden', 'true');
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = deal.collectionBreaks?.buttonText || 'Choose';
      button.setAttribute('aria-label', `${button.textContent} — ${pack.title}, item ${slotIndex + 2}`);
      button.addEventListener('click', (event) => openPicker(bar, slotIndex, event));
      choice.append(plus, button);
      preview.append(choice);
    }
    wrapper.append(preview);
  }

  let scheduled = false;
  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      document.querySelectorAll('kaching-bundles-block').forEach(updateBlock);
    });
  }
  new MutationObserver(scheduleUpdate).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', scheduleUpdate);
  scheduleUpdate();
})();
